export const selectCurrentLoadingState = (state) => state.application.isLoading;